import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  capturedImage: null,
  pndsScore: {
    data: null,
    loading: false,
    success: false,
    error: null,
  },
}

const foodScanSlice = createSlice({
  name: 'foodScan',
  initialState,
  reducers: {
    setCapturedImage: (state, action) => {
      state.capturedImage = action.payload
    },
    generatePndsScoreRequest: (state, action) => {
      state.pndsScore = {
        data: null,
        loading: true,
        success: false,
        error: null,
      }
    },
    generatePndsScoreSuccess: (state, action) => {
      state.pndsScore = {
        data: action.payload,
        loading: false,
        success: true,
        error: null,
      }
    },
    generatePndsScoreError: (state, action) => {
      state.pndsScore = {
        data: null,
        loading: false,
        success: false,
        error: action.payload,
      }
    },
    resetPndsScore: (state, action) => {
      state.capturedImage = null
      state.pndsScore = {
        data: null,
        loading: false,
        success: false,
        error: null,
      }
    },
    setSuccessFlag: (state, action) => {
      state.pndsScore = {
        ...state.pndsScore,
        success: action.payload,
      }
    },
  },
})

export const {
  setCapturedImage,

  //PNDS Score Generation
  generatePndsScoreRequest,
  generatePndsScoreSuccess,
  generatePndsScoreError,
  resetPndsScore,
  setSuccessFlag,
} = foodScanSlice.actions

export default foodScanSlice.reducer
